module.exports = __webpack_public_path__ + "static/Compass-3fa97374dd3bbcdc108fbf519b3cd423.png";